// extracted by mini-css-extract-plugin
export var carrierIcon = "_ts-0";
export var carrierLogo = "_ts-1";
export var detailsSection = "_ts-2";